<style>
@import "@/assets/css/custom.css";
</style>

<template>
	<div>
		<Breadcrumbs main="Accounts" title="Vendor Credits" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">
							<div class="col-md-12 project-list filter-sort">
								<div class="row align-items-end">
									<div class="col-md-8 d-flex mt-2">
										<label class="d-flex listing-length ms-1 align-items-center">
											<span>Show</span>
											<select class="form-select mx-2" style="width: auto" v-model="listing_length" @change="fetchVendorCredits()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									<div class="col-md-4 mt-2">
										<input
											type="text"
											class="form-control"
											placeholder="Search vendor name…"
											v-model="keyword"
											@keyup="fetchVendorCredits()"
										/>
									</div>
								</div>
							</div>

							<div class="table-responsive product-table mt-3">
								<table class="display table align-middle">
									<thead>
										<tr align="center">
											<th>Sl.No</th>
											<th>Vendor</th>
											<th>Due Amount</th>
											<th>Deposited Amount</th>
											<th>Updated</th>
											<th>Action</th>
										</tr>
									</thead>
									<tbody v-if="rows.length">
										<tr align="center" v-for="(row, index) in rows" :key="row.id" class="align-middle">
											<td>{{ from != null ? from + index : index + 1 }}</td>
											<td>{{ row.vendor_name || "—" }}</td>
											<td class="fw-bold text-danger">₹{{ formatMoney(row.due_amount) }}</td>
											<td class="fw-bold text-success">₹{{ formatMoney(row.available_amount) }}</td>
											<td>{{ row.updated_at ? $filters.formatDate(row.updated_at) : "—" }}</td>
											<td>
												<div class="d-flex flex-column align-items-center justify-content-center gap-2">
													<router-link
														:to="{
															name: 'vendor_payment',
															params: { id: row.vendor_id },
															query: { vendor_name: row.vendor_name || '', due_amount: row.due_amount || '0' },
														}"
														class="btn btn-success"
													>
														Pay / invoice payment
													</router-link>
													<router-link
														:to="{
															name: 'vendor_invoices',
															params: { id: row.vendor_id },
															query: { vendor_name: row.vendor_name || '' },
														}"
														class="btn btn-primary"
													>
														Invoices
													</router-link>
												</div>
											</td>
										</tr>
									</tbody>
									<tbody v-else>
										<tr>
											<td colspan="6" align="center">No vendor credits found</td>
										</tr>
									</tbody>
								</table>
							</div>

							<caption v-if="rows.length" class="float-start mt-2 d-block">
								Showing {{ from }} to {{ to }} of {{ total }} entries
							</caption>
							<nav v-if="rows.length && pagination.length" aria-label="Page navigation" class="mt-2 float-end">
								<ul class="pagination mb-0">
									<li
										class="page-item"
										v-bind:class="[{ disabled: !page.url }, { active: page.active }]"
										v-for="(page, index) in pagination"
										:key="'p-' + index + '-' + page.label"
									>
										<a class="page-link" href="#" @click.prevent="onPageClick(page)" tabindex="-1">
											<span v-if="index === 0">Prev</span>
											<span v-else-if="index === pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "VendorCredits",
	data() {
		return {
			token: "",
			keyword: "",
			listing_length: 10,
			rows: [],
			pagination: [],
			from: 0,
			to: 0,
			total: 0,
			active_page_url: "",
		};
	},
	created() {
		this.fetchVendorCredits();
	},
	methods: {
		getToken() {
			if (localStorage.getItem("airotrack_staff")) {
				const airotrack_staff = JSON.parse(localStorage.getItem("airotrack_staff"));
				if (airotrack_staff.token) {
					this.token = airotrack_staff.token;
				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}
			} else {
				this.$swal("", "Session expired, please login again", "error");
				this.$router.push({ name: "login" });
			}
		},

		listUrl() {
			return `/staffs/vendorCredits?limit=${this.listing_length}&keyword=${encodeURIComponent(this.keyword || "")}`;
		},

		fetchVendorCredits(pageUrl) {
			this.getToken();
			const url = pageUrl || this.listUrl();
			this.active_page_url = url;
			this.$axios
				.get(url, { headers: { Authorization: "Bearer " + this.token } })
				.then((res) => {
					if (res.data.status !== "true" && res.data.status !== true) {
						this.rows = [];
						this.pagination = [];
						return;
					}
					const paginator = res.data.data?.vendorCredits;
					this.rows = paginator?.data || [];
					this.pagination = paginator?.links || [];
					this.from = paginator?.from ?? 0;
					this.to = paginator?.to ?? 0;
					this.total = paginator?.total ?? 0;
				})
				.catch((err) => {
					console.error(err);
					this.$swal("Error", err.response?.data?.message || "Failed to load vendor credits", "error");
					this.rows = [];
					this.pagination = [];
				});
		},

		onPageClick(page) {
			if (!page.url) return;
			const base = page.url;
			const sep = base.includes("?") ? "&" : "?";
			this.fetchVendorCredits(`${base}${sep}limit=${this.listing_length}&keyword=${encodeURIComponent(this.keyword || "")}`);
		},

		formatMoney(value) {
			const n = parseFloat(value);
			if (isNaN(n)) return "0.00";
			return n.toFixed(2);
		},
	},
};
</script>

